import type { StoreProductReview } from "../types"

export const selectPdpReviews = (
  reviews: StoreProductReview[],
  selectedIds: string[] | null | undefined,
  limit: number
): StoreProductReview[] => {
  const featured = reviews.filter((review) => review.featured)
  if (selectedIds != null) {
    const byId = new Map(featured.map((review) => [review.id, review]))
    // A removed/unfeatured selected review remains absent, never replaced.
    return selectedIds.flatMap((id) => {
      const review = byId.get(id)
      return review ? [review] : []
    }).slice(0, limit)
  }
  return [...featured].sort((a, b) =>
    (a.featured_position ?? Number.MAX_SAFE_INTEGER) -
      (b.featured_position ?? Number.MAX_SAFE_INTEGER)
  ).slice(0, limit)
}
